import i18n from './locales/index'
import Vue from 'vue'
import App from './app'
import router from './router'
import store from './store'
import config from '@/config'
import ViewUI from 'view-design'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/directives'
import './index.less'
import '@/assets/icons/iconfont.css'
import '@/libs/axios'
import './styles/atom.less';

Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(ElementUI)

Vue.prototype.$config = config

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: (h) => h(App),
  data: {
    currentPageName: ''
  },
  mounted () {
    this.currentPageName = this.$route.name
  }
})
